import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Grid, Pagination } from 'semantic-ui-react';
import Kiosk from '../../api/kiosk';
import { checkForUpdates } from '../../redux/actions';
import { emptyKioskSection, setKiosk } from '../../redux/actions/kiosk';
import { showFloatLevelSettingsModal } from '../../redux/actions/modals';
import Filters from '../kiosk/kioskFilters';
import MachineStatusFilters from '../LiveFloorViewer/MachineStatusFilters';
import DataGrid from '../shared/DataGrid';
import { getControlValues } from '../../helpers/summary';
import { defaultGrid } from '../../helpers/datagrid';

class KioskView extends React.Component {

  state = {
    positionsLoading: false,
    transactionsLoading: false,
    detailsLoading: false,
    summaryLoading: false,
    expanded: false,
    showSummary: true,
    activeRow: { installationId: null },
    statuses: {
      online: true,
      offlineSiteOpen: true,   
      pending: true,
      authReq: true,
      offlineSiteClosed: true,
      onlineEFTDisabled: true,
      onlineNoFunds: true,
    },
    quantities: {
      onlineQty: 0,
      onlineEFTEnabledQty: 0,
      offlineSiteOpenQty: 0,
      pendingQty: 0,
      authReqQty: 0,
      offlineSiteClosedQty: 0,
      unknownQty: 0,
      onlineEFTDisabledQty: 0,
      onlineNoFundsQty: 0,
    },
  }

  componentDidUpdate(prevProps) {

    if (checkForUpdates(prevProps.filters, this.props.filters) ) {
      this.handleRefresh();
    }
  }
 
  handleRefresh = () => {
    const site = this.props.filters.filterSelected.site.id;
    const operator = this.props.filters.filterSelected.operator;
    const company = this.props.filters.filterSelected.company.id;
    const subcompany = this.props.filters.filterSelected.subcompany.id;

    const { online, offlineSiteOpen, offlineSiteClosed, pending, authReq } = this.state.statuses;

    this.setState({ positionsLoading: true }, () => {
      Kiosk.Positions(
        operator,
        company || -1,
        subcompany || -1,
        site || -1,
        online,
        offlineSiteOpen,
        offlineSiteClosed,
        pending,
        authReq
      ).then(
        positions => {
          const activeRow = positions.grid.data.find(x => x.installationId === this.state.activeRow.installationId) || { installationId: null }
          this.props.setKiosk({ positions, details: defaultGrid }).then(
            () => {
              const quantities = {
                ...this.state.quantities,
                // Spread only the items from the response that are already in the original quantities object, it's unnecessary, but it just keeps clean data. 
                ...Object.fromEntries(Object.entries(positions).filter(([key]) => Object.keys(this.state.quantities).includes(key)))
              }
              this.setState({ quantities, activeRow, positionsLoading: false }, () => {
                if (activeRow.installationId) {
                  this.onTransactionsRefresh()
                } else {
                  this.props.setKiosk({ transactions: defaultGrid, summary: defaultGrid })
                }
              })
            }
          );
        },
        () => this.setState({ positionsLoading: false })
      )
    })
  }

  onTransactionsRefresh = () => {
    const { includeEvents, fromDate, page, currentDate } = this.props.data.filters
    const toDate = currentDate ? moment() : this.props.data.filters.toDate;
    const { activeRow } = this.state;
    const details = getControlValues(this.props.data.summary.grid.data);

    this.setState({ transactionsLoading: true }, () => {
      Kiosk.Transactions(activeRow.installationId, fromDate, toDate, includeEvents, details, page).then(
        ({ transactions, summary }) => this.props.setKiosk({ activeRow, transactions, summary, details: defaultGrid }).then(() => this.setState({ transactionsLoading: false })),
        () => this.setState({ transactionsLoading: false })
      )
    })
  }

  onPositionClick = activeRow => this.setState({ activeRow }, () => this.onTransactionsRefresh())

  onTransactionClick = activeRow => {
    const { installationId } = this.props.data.activeRow;
    const { detailId } = activeRow;

    this.setState({ detailsLoading: true }, () => {
      Kiosk.Detail(installationId, detailId).then(
        details => this.props.setKiosk({ details }).then(() => this.setState({ detailsLoading: false })),
        () => this.setState({ detailsLoading: false })
      )
    });
  }

  handleFilterChange = async (name, value) => {
    this.props.setKiosk({ filters: { ...this.props.data.filters, [name]: value } })
  }

  handleOptionChange = (option, value) => {    
    const { grid } = this.props.data.summary;
    const data = [...grid.data];

    data.forEach((row, rowIndex) => {
      row.cellData.forEach((cell, cellIndex) => {
        if (cell.data.code === option.code) {
          data[rowIndex].cellData[cellIndex].data = {...option}
        }
      })
    })

    const summary = {...this.props.data.summary, grid: {...grid, data } }

    this.props.setKiosk({ ...this.props.data, summary })
  }

  onPageChange = (event, { activePage }) => this.handleFilterChange("page", activePage).then(() => this.onTransactionsRefresh())

  onSettingsClick = () => {
    const { installationId } = this.state.activeRow;

    Kiosk.Floats(installationId).then(result => {
      this.props.showFloatLevelSettingsModal(result);
    })
  }

  handleStatusChange = (key, value) => {
    let statuses = {...this.state.statuses};
    statuses[key]=!statuses[key];
    this.setState({ statuses }, () => {
      if (this.props.filters.hasSelection) this.handleRefresh()
    });
  }

  render() {
    const { details, positions, transactions, summary, filters } = this.props.data;
    const { page } = filters;
    const { showSummary, statuses, expanded, quantities, positionsLoading, transactionsLoading, summaryLoading, detailsLoading, activeRow} = this.state;

    let transactionsWidth = !showSummary ? 13 : 9;

    if (summary.grid.data.length < 1) {
        transactionsWidth += 4;
    }

    if (details.grid.data.length < 1 || transactionsLoading) {
      transactionsWidth += 3;
    }

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column>
            <MachineStatusFilters 
              onStatusChange={this.handleStatusChange}
              onRefreshClick={this.handleRefresh}
              filters={filters}
              statuses={statuses}
              quantities={quantities}
              disabled={positionsLoading || !this.props.filters.hasSelection}
              onSettingsClick={this.onSettingsClick}
              expanded={expanded}
              onExpandClick={() => this.setState({ expanded: !this.state.expanded })}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column stretched>
            <DataGrid
              loading={positionsLoading}
              headings={positions.grid.headerDef}
              activeRow={this.state.activeRow}
              data={positions.grid.data}
              rowDef={positions.grid.rowDef}
              onRowClick={this.onPositionClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
        {!expanded &&
            <Grid.Row>
              <Grid.Column>
                <Filters
                  handleChange={this.handleFilterChange}
                  disabled={!activeRow.installationId}
                  onRefresh={(e) => this.onPageChange(e, { activePage: 1 })}
                  onSummaryClick={() => this.setState({ showSummary: !showSummary })}
                  showSummary={showSummary}
                />
              </Grid.Column>
            </Grid.Row>
          }
          {!expanded &&
            <Grid.Row style={{ minHeight: "60%" }} className="flex-stretch">
              {(showSummary && summary.grid.data.length > 0) &&
                <Grid.Column width="4" stretched>
                  <DataGrid
                    hideOverflow
                    loading={summaryLoading}
                    headings={summary.grid.headerDef}
                    data={summary.grid.data}
                    rowDef={summary.grid.rowDef}
                    disableActiveRow
                    onOptionChange={this.handleOptionChange}
                  />
                </Grid.Column>
              }
              <Grid.Column width={transactionsWidth} stretched>
                <DataGrid
                  loading={transactionsLoading}
                  headings={transactions.grid.headerDef}
                  data={transactions.grid.data}
                  rowDef={transactions.grid.rowDef}
                  onRowClick={this.onTransactionClick}
                  fullHeight
                />
                {transactions.pageCount > 1 &&
                  <div className="mt-1 flex-shrink">
                    <Pagination className="flex-shrink" size="mini" key="pagination" activePage={page} totalPages={transactions.pageCount} onPageChange={this.onPageChange} />
                  </div>
                }
              </Grid.Column>
              {(details.grid.data.length > 0 && !transactionsLoading) &&
                <Grid.Column width="3" stretched>
                  <DataGrid
                    loading={detailsLoading}
                    headings={details.grid.headerDef}
                    data={details.grid.data}
                    fullHeight
                    rowDef={details.grid.rowDef}
                  />
                </Grid.Column>
              }
            </Grid.Row>
        }
      </Grid>
    );
  }
}

const mapStateToProps = state => {
	return {
    filters: state.kioskFilters,
    data: state.kiosk
  };
};

export default connect(mapStateToProps, { showFloatLevelSettingsModal, setKiosk, emptyKioskSection })(KioskView);
